import { createSelector } from '@reduxjs/toolkit';

export const getPaymentsState = (state) => state.payments;

export const getPayments = createSelector(getPaymentsState, (paymentsState) => paymentsState.data);
